<section class="gain-section">
  <div class="container">
    <!-- Section Header Text -->
    <div class="row mb-5">
      <div class="col-lg-12">
        <h1 class="gain-title">WHAT STUDENTS GAIN?</h1>
        <p class="section-intro">
          Participating students gain access to nationally recognised
          certification, hackathon opportunities, and pathways to the IndiaAI
          Fellowship programme.
        </p>
      </div>
    </div>

    <!-- Cards Dynamic Layout Grid -->
    <div class="gain-grid">
      <div
        class="gain-card"
        *ngFor="let card of gainCards"
        [ngClass]="card.colorClass"
      >
        <!-- Image Box Frame Container -->
        <div class="card-image-box">
          <img [src]="card.imageSrc" [alt]="card.title" class="gain-card-img" />
        </div>

        <!-- Text Content Area -->
        <div class="card-text-content">
          <h5 class="card-title">{{ card.title }}</h5>
          <p class="card-desc">{{ card.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
